import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/DangerousGoodsDeclaration/components/SectionPurpose/SectionPurpose.module.scss';

const cn = classNames.bind(styles);

const SectionPurpose = (): ReactElement => {
  return (
    <section className={cn('purpose')}>
      <div className={cn('container')}>

        <div className={cn('purpose__section')}>

          <div className={cn('purpose__image-box')}>
            <picture>
              <source
                srcSet="
                /images/pages/Resources/FreightTemplates/sign-in.webp 1x,
                /images/pages/Resources/FreightTemplates/sign-in@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('purpose__image')}
                src="/images/pages/Resources/FreightTemplates/sign-in.webp"
                alt="bill of lading"
              />
            </picture>
          </div>

          <div className={cn('purpose__content')}>
            <h2 className={cn('purpose__heading')}>
              <span>Why is the DGD</span>{' '}
              <span>critical?</span>
            </h2>
            <p className={cn('purpose__paragraph')}>
              Beyond general safety, the DGD serves three specific operational functions:
            </p>
            <ul className={cn('purpose__list')}>
              <li className={cn('purpose__list-item')}>
                <span>Carrier Acceptance:</span>{' '}
                No captain will authorize the loading of hazardous cargo without a
                DGD. If the weight listed on the paper doesn't match the physical cargo, the shipment
                stays on the tarmac.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Liability and Warranty:</span>{' '}
                By signing the DGD, the shipper warrants that the goods are
                safe for transport. If undeclared chemicals cause a fire or incident, the shipper bears
                full legal and financial liability.
              </li>
              <li className={cn('purpose__list-item')}>
                <span>Emergency Response:</span>{' '}
                In the event of an accident, the DGD tells emergency
                responders exactly what chemicals they are dealing with so they know how to fight the
                fire or contain the spill.
              </li>
            </ul>
          </div>

        </div>

      </div>
    </section>
  );
};

export default SectionPurpose;